import { userActionTypes } from '../actionTypes/user.actionTypes';

export const userTypes = {
    ...userActionTypes,
};
